<!-- eslint-disable vue/multi-word-component-names -->
<!-- The corridor tablet's layout, and it is a layout rather than a page wrapper for one
     reason: this screen has no session, no navigation and no topbar, and the Default
     layout's tab strip would offer a housekeeper's round to whoever walks past.

     Full bleed, because the thing on it is a keypad somebody uses with a thumb from
     half a metre away, and because a tablet left on a wall for a year should not be
     drawing a card with a margin round it. -->
<template>
    <div class="flex min-h-dvh flex-col bg-default">
        <slot>
            <RouterView />
        </slot>
    </div>
</template>

<script lang="ts" setup>
</script>
